import Link from '@/components/Link';
import Logo from '@/components/Logo';
import { AppBar, IconButton, Toolbar } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  navIcon: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  logo: {
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
    },
    display: 'none',
    // borderRadius: 5,
    // width: 43,
    // height: 43,
  },
  select: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
}));

interface AppToolbarProps {
  onDrawerOpen: React.ReactEventHandler<unknown>;
  children: React.ReactNode;
}

export default function AppToolbar({
  onDrawerOpen,
  children,
}: AppToolbarProps): JSX.Element {
  const classes = useStyles();

  return (
    <AppBar className={classes.appBar} color="default">
      <Toolbar>
        <IconButton
          edge="start"
          className={classes.navIcon}
          color="inherit"
          aria-label="menu"
          onClick={onDrawerOpen}
        >
          <MenuIcon />
        </IconButton>

        <Link
          className={classes.logo}
          href="/"
          color="primary"
          underline="none"
        >
          <Logo />
        </Link>

        {children}
      </Toolbar>
    </AppBar>
  );
}
